export const defaultDatePickerDateFormat = [
    { text: '${date|d|ddd}', className: 'v-date-picker-date__day-of-week' },
    { text: '${date|d|D}', className: 'v-date-picker-date__day-of-month' },
    { text: '${date|d|MMM}', className: 'v-date-picker-date__month' }
];
export const defaultDatePickerTodayDateFormat = 'Today';
export const defaultDatePickerCarouselConfig = {
    showPositionIndicators: false,
    settings: {
        slidesToScroll: 'auto',
        watchDrag: true,
        dragFree: true
    }
};
//# sourceMappingURL=props.js.map